/* eslint-disable import/prefer-default-export */
import url from 'url';

// This is a helper function to get params from the url
// and returns an object with queryParam: queryValue from url
// If a given param is not found in url, it is returned with value of undefined
export const getQueryParams = () => (typeof window !== 'undefined' ? url.parse(window.location.toString(), true).query : {});
